// What a cluster knows before it is opened: how many churches, how many with
// confession and adoration, how many with Mass in Spanish, and the
// cathedrals, basilicas and shrines inside it. On hover a card; on click the
// camera eases in and the cluster resolves.

import { esc } from './panel.js';
import { markSvg } from './marks.js';

export function createClusterCard(ctx) {
  const { t, mapApi } = ctx;
  const el = document.getElementById('atlasCluster');
  let pinned = null;

  function place(point) {
    const wrap = mapApi.map.getContainer().getBoundingClientRect();
    const w = el.offsetWidth || 240, h = el.offsetHeight || 120;
    let x = point.x + 14, y = point.y - 12;
    if (x + w > wrap.width - 8) x = point.x - w - 14;
    if (y + h > wrap.height - 8) y = wrap.height - h - 8;
    if (y < 8) y = 8;
    el.style.transform = `translate(${Math.round(x)}px, ${Math.round(y)}px)`;
  }

  function html(f, leaves) {
    const p = f.properties;
    const n = p.point_count || p.n || 0;
    const rows = [];
    if (p.point_count) {
      if (p.hc) rows.push(t('cluster.confession', { n: p.hc }));
      if (p.ha) rows.push(t('cluster.adoration', { n: p.ha }));
      if (p.sp) rows.push(t('cluster.spanish', { n: p.sp }));
    }
    const notable = (leaves || []).filter((l) => l.properties.k !== 'p').slice(0, 3);
    return `<p class="atlas-cluster-n">${esc(t('cluster.churches', { n }))}</p>
      ${rows.length ? `<ul>${rows.map((r) => `<li>${esc(r)}</li>`).join('')}</ul>` : ''}
      ${notable.length ? `<p class="atlas-cluster-notable">${notable.map((l) => `<button type="button" class="atlas-link" data-id="${esc(l.properties.i)}">${markSvg(l.properties.k, 12)} ${esc(l.properties.n)}</button>`).join('')}</p>` : ''}
      ${pinned ? `<p class="atlas-cluster-actions"><button type="button" class="atlas-btn" data-zoom>${esc(t('cluster.zoom'))}</button>${p.point_count ? `<button type="button" class="atlas-btn" data-list>${esc(t('cluster.list'))}</button>` : ''}</p>` : ''}`;
  }

  async function show(f, point, pin) {
    pinned = pin ? f : null;
    el.innerHTML = html(f, null);
    el.hidden = false;
    place(point);
    if (f.properties.cluster_id != null && f.source === 'churches') {
      const leaves = await mapApi.clusterLeaves(f);
      if (el.hidden) return;
      el.innerHTML = html(f, leaves);
      el.dataset.leaves = String(leaves.length);
      el._leaves = leaves;
      place(point);
    }
  }
  function hide(force) { if (pinned && !force) return; pinned = null; el.hidden = true; el._leaves = null; }

  el.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-id]');
    if (b) { hide(true); ctx.onSelect(b.dataset.id, 'cluster'); return; }
    if (e.target.closest('[data-zoom]') && pinned) { const f = pinned; hide(true); ctx.onZoom(f); return; }
    if (e.target.closest('[data-list]') && pinned) { const ids = (el._leaves || []).map((l) => l.properties.i); hide(true); ctx.onList(ids); }
  });
  el.addEventListener('mouseleave', () => hide(false));

  return { show, hide, isPinned: () => !!pinned };
}
